<!--
일괄정상처리 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">

        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xlarge">
            <!-- 컨펌 팝업 -->
            <div v-show="display === 'confirm'">
                <div class="uk-modal-header">
                    <i class="material-icons">info</i>
                    일괄정상처리
                </div>
                <div class="uk-modal-body uk-padding uk-text-large3 uk-text-center app-color-black">
                    선택한
                    <span class="uk-text-primary uk-text-large4">{{ selectedQty }}</span>
                    개 상품을 일괄 정상처리 합니까?
                </div>

                <div class="uk-modal-footer uk-text-center">
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-button-large2 uk-margin-right uk-modal-close"
                    >
                        <i class="material-icons">close</i>
                        취소
                    </button>
                    <button
                        type="button"
                        class="uk-button uk-button-primary uk-button-large2"
                        @click="submit"
                    >
                        <i class="material-icons">check</i>
                        확인(정상)
                    </button>
                </div>
            </div>

            <!-- 처리중 팝업 -->
            <div v-show="display === 'sending'">
                <div class="uk-modal-header">
                    <i class="material-icons">info</i>
                    일괄정상처리
                </div>
                <div class="uk-modal-body uk-padding uk-text-large uk-text-center app-color-black">
                    <loading-icon
                        class="uk-text-middle"
                        bg-color="#ccc"
                        fore-color="#333"
                    ></loading-icon>
                    처리중...
                </div>
            </div>

            <!-- 보관장소 팝업 -->
            <div v-show="display === 'storage'">
                <div class="uk-modal-header">
                    <i class="material-icons">info</i>
                    일괄정상처리 - 보관장소 입력
                </div>
                <div class="uk-modal-body uk-padding">
                    <app-input-ex
                        class="uk-margin-bottom"
                        type="text"
                        input-size="large"

                        name="memo"
                        v-model="storage"
                        label="보관장소"

                        required-layout="label-left"

                        placeholder="보관장소를 입력하세요"
                    > </app-input-ex>

                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button
                        type="button"
                        class="uk-button uk-button-primary uk-button-large2"
                        v-on:click="saveStorage"
                    >
                        <span uk-icon="icon: check"></span>
                        보관장소 입력
                    </button>
                </div>
            </div>

            <!-- 라벨출력 팝업 -->
            <div v-show="display === 'label'">
                <div class="uk-modal-header">
                    <i class="material-icons">info</i>
                    일괄정상처리 - 라벨출력
                </div>
                <div class="uk-modal-body uk-padding">
                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        합배송 상품이 아직 준비되지 않아, [발송대기] 처리되었습니다<br />
                        보관라벨 출력 후 상품을 보관하세요
                    </div>

                    <div class="uk-text-large4 uk-text-center uk-margin-bottom uk-text-primary">
                        {{ storage }}
                    </div>

                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2"
                            onclick="$.app.print.store_label(arguments);"
                            :data-prod-id="firstProdId"
                            title="현재 상품의 보관라벨을 출력합니다"
                        >
                            <i class="material-icons" style="font-size: 48px; vertical-align: middle">print</i>
                            <span class="text">PRINT STORE-LABEL (보관라벨)</span>
                        </button>
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-right">
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-button-large2 uk-margin-right"
                        @click="display = 'storage'"
                    >
                        <i class="material-icons">keyboard_arrow_left</i>
                        뒤로 (보관장소 수정)
                    </button>
                    <button
                        type="button"
                        class="uk-button uk-button-primary uk-button-large2"
                        @click="done"
                    >
                        <i class="material-icons">check</i>
                        완료
                    </button>
                </div>
            </div>
        </div>



    </div>

</template>

<script>
    export default {
        components: {
            'loading-icon': require('../../../../common/loading-icon.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 선택한 상품ID 배열
             */
            prodIds: Array,

            /**
             * 선택한 상품 총 수량
             **/
            selectedQty: Number,
        },
        data: function () {
            return {
                /**
                 * (string) display 화면
                 *  - confirm
                 *  - sending
                 *  - storage
                 *  - label
                 */
                display: null,

                /**
                 * 보관장소
                 */
                storage: null,

                /**
                 * (string) 정상처리의 결과
                 *      - 'out-ready'
                 *      - 'pack-ready'
                 **/
                resultState: null,

                /**
                 * (int) 하우스ID
                 **/
                houseId: null,

            };
        },
        computed: {
            // 첫번째 상품번호
            firstProdId() {
                return _.first(this.prodIds);
            },
        },
        mounted() {
        },
        methods: {
            /**
             * 일괄정상처리
             */
            setOk() {
                // 선택된 상품이 없는지 검증
                if (this.prodIds.length === 0) {
                    alert('선택된 상품이 없습니다');
                    return;
                }

                // 모달창
                UIkit.modal(this.$el).show();

                // 컨펌창
                //this.display = 'confirm';

                // 바로 서브밋 진행
                this.submit();
            },

            /**
             * 서브밋
             */
            submit() {
                // 전송중
                this.display = 'sending';

                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/batch-out-ready',
                        data: {
                            '_token': this.csrfToken,
                            'prod_ids': this.prodIds,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        alert_error_msg: function(msg) {
                            reject(msg);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                p.then((response) => {
                    // 결과저장
                    this.storage = response.storage;
                    this.resultState = response.state;
                    this.houseId = response.house_id;

                    // 패킹대기 구분
                    if (this.resultState === 'pack-ready') {
                        // 모달 종료
                        UIkit.modal(this.$el).hide().then(() => {
                            // 패킹작업 이벤트발생
                            this.$emit('done:pack', this.houseId);
                        });
                        return;
                    }



                    // 보관장소가 발급되었으면, 입력단계 건너뜀
                    if (this.storage) {
                        // 라벨발급 화면
                        this.display = 'label';
                    } else {
                        // 보관장소 입력화면
                        this.display = 'storage';
                    }

                }).catch((msg) => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide().then(() => {
                        this.$emit('check:exception', msg);
                    });
                    //return;
                });
            },


            /**
             * 보관장소저장 완료처리
             */
            saveStorage() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/batch-update-storage',
                        data: {
                            '_token': this.csrfToken,
                            'prod_ids': this.prodIds,
                            'storage': this.storage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        alert_error_msg: function(msg) {
                            reject(msg);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    // 라벨발급 화면
                    this.display = 'label';
                }).catch((msg) => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide().then(() => {
                        this.$emit('check:exception', msg);
                    });
                    //return;
                });
            },


            /**
             * 완료처리
             */
            done() {
                UIkit.modal(this.$el).hide().then(() => {
                    this.$emit('done:ready');
                });
            },

        },
    }
</script>

<style lang="scss" scoped>
    .uk-modal-header {
        background-color: #fafafa;
        color: #000;
        font-size: 1.75rem;
        text-align: center;

        .material-icons {
            font-size: 2.5rem;
        }
    }
</style>